import { render } from "./ProduitVendus.vue?vue&type=template&id=71a9cd1c&scoped=true"
import script from "./ProduitVendus.vue?vue&type=script&lang=js"
export * from "./ProduitVendus.vue?vue&type=script&lang=js"

import "./ProduitVendus.vue?vue&type=style&index=0&id=71a9cd1c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a9cd1c"]])

export default __exports__